import template from './checklistAdd.template.html';

export default {
  template,
  bindings: {
    checklists: '<',
    onCancelled: '&',
    onFinished: '&'
  },
controller: class controller {
    constructor($timeout, $mdMedia, uiService, Checklist, ChecklistItem) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.checklist = ChecklistItem.blank();

        ctrl.checklist.due =
          ctrl.checklist && ctrl.checklist.items && ctrl.checklist.items.length
            ? ctrl.checklist.items[0].due
            : 7;
        ctrl.checklists = ctrl.checklists ? ctrl.checklists : [];
        _.forEach(ctrl.checklists, (c) => {
          const checklist = c;
          checklist.isSelected = false;
        });
        ctrl.selectedChecklists = [];
        ctrl.pickIcon = false;
        ctrl.isSingle = true;
        ctrl.startSaveProcess = false;
      };
      ctrl.modifyDueItems = () => {
        const len = ctrl.checklist.items.length;
        for (let i = 0; i < len; i += 1) {
          ctrl.checklist.items[i].due = ctrl.defaultItemDue;
        }
      };
      ctrl.select = (checklistSelected) => {
        const checklist = checklistSelected;
        checklist.isSelected = !checklist.isSelected;
        const idx = _.findIndex(ctrl.selectedChecklists, (d) => d.id === checklist.id);
        if (idx === -1) {
          ctrl.selectedChecklists.push(checklist);
        } else {
          ctrl.selectedChecklists.splice(idx, 1);
        }
      };
      ctrl.toggleAddOption = () => {
        ctrl.isSingle = !ctrl.isSingle;
        if (ctrl.isSingle) {
          ctrl.checklist = ChecklistItem.blank();
          ctrl.selectedChecklists = [];
          _.forEach(ctrl.checklists, (c) => {
            const checklist = c;
            checklist.isSelected = false;
          });
        } else {
          ctrl.checklist = Checklist.blank();
        }
      };
      ctrl.cancel = () => {
        ctrl.startSaveProcess = true;
        ctrl.onCancelled();
        $timeout(() => {
          ctrl.initialize();
        });
      };
      ctrl.confirm = () => {
        if (ctrl.isSingle) {
          if (ctrl.checklist.name !== '') {
            ctrl.onFinished({ checklists: ctrl.checklist, isSingle: true });
            ctrl.cancel();
          } else {
            uiService.toast({
              text: {
                p1: 'Checklist',
                p2: 'name',
                p3: 'is required'
              },
              warn: true
            });
          }
        } else {
          ctrl.onFinished({ checklists: ctrl.selectedChecklists, isSingle: false });
          ctrl.cancel();
        }
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
